<template>
    <div>
        <ModalContainer :visible="visible && !deleteAppointmentModalVisible && !updateAppointmentModalVisible" :loading="loading">
            <template v-slot:header>
                <button type="button" class="close" @click="$emit('close-appointment-modal')"><i class="las la-times"></i></button>
                <h4 class="modal-title" v-if="hasSingleAppointment">{{ $t('components.appointment.update_appointment')}}</h4>
                <h4 class="modal-title" v-else-if="hasMultipleAppointments">{{ $t('components.appointment.update_dates')}}</h4>
            </template>
            <template v-slot:body>
                <div class="form-group" v-show="errorMessage">
                    <div class="alert alert-danger" style="margin: 0 10px;">
                        {{errorMessage}}
                    </div>
                </div>
                <UpdateAppointmentForm @change="onChangeAppointment" :update-appointments-prop="updateAppointments"></UpdateAppointmentForm>
            </template>
            <template v-slot:footer>
                <a class="btn btn-primary btn-lg btn-block"
                   href=""
                   @click.prevent.stop="showUpdateAppointmentModal()">
                    <i class="las la-check"></i>
                    <span v-if="hasSingleAppointment">
                                    {{ $t('components.appointment.update_appointment')}}
                                </span>
                    <span v-else-if="hasMultipleAppointments">
                                    {{ $t('components.appointment.update_dates')}}
                                </span>
                </a>
                <a class="btn btn-danger btn-lg btn-block"
                   href=""
                   @click.prevent.stop="showDeleteAppointmentModal">
                    <i class="las la-trash"></i>
                    <span v-if="hasSingleAppointment">
                                    {{ $t('components.appointment.delete_appointment')}}
                                </span>
                    <span v-else-if="hasMultipleAppointments">
                                    {{ $t('components.appointment.delete_dates')}}
                                </span>
                </a>
            </template>
        </ModalContainer>


        <GenericChooseModal
                :message="$t('components.appointment.modal_delete_message')"
                :title="$t('components.appointment.delete_appointment')"
                :visible="deleteAppointmentModalVisible"
                :positive-button-text="$t('components.appointment.modal_delete_positive')"
                :negative-button-text="$t('components.appointment.modal_delete_negative')"
                danger
                @positive-click-generic-modal="positiveButtonDeleteAppointmentModalClick"
                @negative-click-generic-modal="negativeButtonDeleteAppointmentModalClick"
                @close-generic-modal="negativeButtonDeleteAppointmentModalClick"
        />

        <GenericChooseModal
                :message="$t('components.appointment.modal_update_message')"
                :title="$t('components.appointment.update_appointment')"
                :visible="updateAppointmentModalVisible"
                :positive-button-text="$t('components.appointment.modal_update_positive')"
                :negative-button-text="$t('components.appointment.modal_update_negative')"
                @positive-click-generic-modal="positiveButtonUpdateAppointmentModalClick"
                @negative-click-generic-modal="negativeButtonUpdateAppointmentModalClick"
                @close-generic-modal="negativeButtonUpdateAppointmentModalClick"
        />
    </div>


</template>

<script>
    import UpdateAppointmentForm from "../appointment/UpdateAppointmentForm";
    import {updateAppointments, deleteAppointmentSet} from "../../api";
    import ModalContainer from "./ModalContainer";
    import i18n from "../../i18n"
    import GenericChooseModal from "./GenericChooseModal";

    export default {
        name: "UpdateAppointmentModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            appointmentSetProp: {
                type: Object,
                default: null
            }
        },
        data: () => {
            return {
                deleteAppointmentModalVisible: false,
                updateAppointmentModalVisible: false,
                loading: false,
                updateAppointments: {
                    appointments: [],
                    notify: false,
                    location: null
                },
                errorMessage: ""
            }
        },
        computed: {
            hasMultipleAppointments: function () {
                return (this.updateAppointments.appointments && this.updateAppointments.appointments.length > 1)
            },
            hasSingleAppointment: function () {
                return (this.updateAppointments.appointments && this.updateAppointments.appointments.length === 1)
            }
        },
        components: {ModalContainer, UpdateAppointmentForm, GenericChooseModal},
        methods: {
            async positiveButtonDeleteAppointmentModalClick() {
                this.deleteAppointmentModalVisible = false;
                this.$nextTick(() => {
                    this.deleteAppointment();
                });
            },
            negativeButtonDeleteAppointmentModalClick() {
                this.deleteAppointmentModalVisible = false;
                this.$nextTick(() => {
                    this.$emit('close-appointment-modal');
                });
            },
            showDeleteAppointmentModal() {
                this.deleteAppointmentModalVisible = true;
            },

            async positiveButtonUpdateAppointmentModalClick() {
                this.updateAppointmentModalVisible = false;
                this.$nextTick(() => {
                    this.updateAppointment();
                });
            },
            negativeButtonUpdateAppointmentModalClick() {
                this.updateAppointmentModalVisible = false;
                this.$nextTick(() => {
                    this.$emit('close-appointment-modal');
                });
            },
            showUpdateAppointmentModal() {
                this.updateAppointmentModalVisible = true;
            },
            onChangeAppointment(appointments) {
                if (appointments.notify == null) {
                    appointments.notify = true;
                }
                this.updateAppointments = appointments;
            },
            async updateAppointment() {
                this.errorMessage = "";
                this.loading = true;
                try {
                    await updateAppointments(this.updateAppointments.appointments, this.updateAppointments.id, this.updateAppointments.is_online, this.updateAppointments.location, this.updateAppointments.notify);

                    this.$emit('success-update-appointment');
                    this.loading = false;

                    if (this.hasSingleAppointment) {
                        this.$route.params.successMessage = i18n.t('components.appointment.update_success_single');
                    } else if (this.hasMultipleAppointments) {
                        this.$route.params.successMessage = i18n.t('components.appointment.update_success');
                    }


                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async deleteAppointment() {
                this.errorMessage = "";
                this.loading = true;
                try {
                    await deleteAppointmentSet(this.updateAppointments.id);

                    this.$emit('success-delete-appointment');
                    this.loading = false;

                    if (this.hasSingleAppointment) {
                        this.$route.params.successMessage = i18n.t('components.appointment.delete_success_single');
                    } else if (this.hasMultipleAppointments) {
                        this.$route.params.successMessage = i18n.t('components.appointment.delete_success');
                    }

                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
        },
        watch: {
            visible(newVal) {
                if (newVal) {
                    this.updateAppointments = this.appointmentSetProp;
                }
            }
        }
    };
</script>
